<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3tejv0/tc-custom/9781528919562.jpg?1716034470129" alt="This image is the cover for the book The Web"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Web
      </h1>
      <p class="bookDescription body article font2">
        <p>In a celestial realm of five planets orbiting four suns, echoes of a bygone civilization wait to be unearthed. The revelation comes when archaeologists stumble upon an enigmatic probe amidst ancient ruins. As they pry open this time capsule, they unveil the chilling tale of a civilization vanished, its demise tied to a rogue blue star mentioned in the ancient texts. As astronomers cast their gaze towards the cosmos, they are startled to find the same blue star, now drawing closer, heralding changes both mysterious and ominous. The celestial menace, with its destructive energies, threatens to rewrite the destiny of this multi-sunned system. Faced with a cosmic threat, the realm’s brightest minds rally together to conceive a grand design: a force field monumental in its making, envisioned to shield their world from the star’s ruinous touch. This colossal endeavour births... The Web.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Liam B. Dei
      </h2>
      
      <p class="authorDescription body article">Growing up on the east-side of Vancouver BC in the 60s there was no internet, no computer games; just pinball, and, by the mid-70s, Pacman, so we were to make our own games or play board games, which we did. We also did stupid things when it got boring like dekes where we would run down a crowded street and try not to hit anyone. Jail tag on bikes. As I got older, I started to read about WWII but it got boring so I began reading horror and science fiction.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36efff72